var exports = {
  "N": "x2b2fbebb--e9df72--element",
  "c": "x2b2fbebb--e9df72--element--inline",
};

module.exports = exports;
